import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleNavigation from "./SimpleNavigation";
import MobileNavigation from "./MobileNavigation";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Handle scroll behavior for header
    const handleScroll = () => {
      const header = document.querySelector(".header");
      if (header) {
        if (window.scrollY > 0) {
          header.classList.add("scrolled");
        } else {
          header.classList.remove("scrolled");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.classList.toggle("menu-open");
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.classList.remove("menu-open");
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-top">
          <div className="header-actions">
            <Link to="/book-demo" className="header-link">
              <div className="enterprise-link-highlighted">Encountered a security incident?</div>
              <span className="demo-icon"></span>Book a demo
            </Link>
            <a href="https://r.spidersilk.com" className="header-link" target="_blank" rel="noreferrer">
              <span className="single-user-icon"></span>Sign In
            </a>
            <a href="https://spidersilk.teamtailor.com" className="header-link" target="_blank" rel="noreferrer">
              <span className="careers-icon"></span>Careers
              <span className="hiring-badge">We're hiring!</span>
            </a>
            {/* <a href="#" className="header-link">
              <span className="mail-icon"></span>Contact Us
            </a> */}
          </div>
        </div>
        <nav className="navbar">
          <div className="logo">
            <Link to="/">
              <img src="/images/spidersilk-logo.svg" alt="spiderSilk Logo" className="logo-img" />
            </Link>
          </div>

          {/* Navigation Component */}
          <SimpleNavigation />

          <button className={`burger ${isMenuOpen ? "active" : ""}`} aria-label="Menu button" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Mobile Navigation */}
          <MobileNavigation isOpen={isMenuOpen} onClose={closeMenu} />
        </nav>
      </div>
    </header>
  );
};

export default Header;
